export enum STATUS {
    OPENED,
    CLOSED,
}
